import DataStore from '@/engine/stores/data-store';

class WorkTrackerCategoryDataStore extends DataStore {

}

export default new WorkTrackerCategoryDataStore();
